<template>
<!--<v-container>-->
    <v-card >
        <v-card-title primary-title>
           <v-btn flat icon color="primary">
                              
                      <v-icon large >mdi-account-circle</v-icon>                  
                   
                </v-btn>
            <span class="headline">{{labels.personal_data}}:  {{datimainguest.firstName}}</span >
        </v-card-title>
        <v-container>


            <v-form v-model="valid" ref="form">

                <v-text-field
                :label="labels.firstname"
                v-model="user.firstName"
                :rules="nameRules"
                required></v-text-field>

                <v-text-field
                :label="labels.lastname"
                v-model="user.lastName"
                :rules="nameRules"
                required></v-text-field>

                <v-select
                :label="labels.gender"
                v-model="user.gender"
                :items="genders"
                item-text="Descrizione"
                item-value="Codice"
                return-object
                required></v-select>

                <label style="color:#0000008a; font-size: 12px;" >{{labels.dateofbirth}}</label>
                <v-row>
                <v-col>
                <v-select
                :label="labels.dayofbirth"
                v-model="user.dayofbirth"
                :items="days"
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>

                <v-col>
                <v-select
                :label="labels.monthofbirth"
                v-model="user.monthofbirth"
                :items="months" 
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>
                <v-col>
                <v-combobox
                :label="labels.yearofbirth"
                v-model="user.yearofbirth"
                :items="years"
                return-object
                :rules="nameRules"
                required></v-combobox>
                </v-col>
                </v-row>
        
                <!--<v-text-field
                :label="labels.dateofbirth"
                v-model="user.dateofbirth"
                type="date"
                required></v-text-field>
                -->


                <v-autocomplete
                :label="labels.countryofresidence"
                v-model="user.countryofresidence"
                :items="countries"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                :search-input.sync="searchcountry"
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-autocomplete>

                <!--<v-combobox
                v-if="user.countryofresidence && user.countryofresidence.Codice === config.iditalia"
                :label="labels.cityofresidence"
                v-model="user.cityofresidence"
                :items="cities"
                :rules="[v => !!v || 'Campo obbligatorio']"
                autocomplete
                :search-input.sync="searchcity_res"
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-combobox>
                -->
                <v-autocomplete
                v-if="user.countryofresidence && user.countryofresidence.Codice === config.iditalia"
                :label="labels.cityofresidence"
                v-model="user.cityofresidence"
                :items="cities"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-autocomplete>

                <v-text-field
                :label="labels.addressofresidence"
                v-model="user.addressofresidence"
                required></v-text-field>               

                <v-text-field
                v-if="user.countryofresidence && user.countryofresidence.Codice !== config.iditalia"
                :label="labels.cityofresidence"
                v-model="user.foreignlocation"
                :rules="[v => !!v || 'Campo obbligatorio']"
                required
                ></v-text-field>
                
                <v-autocomplete
                :label="labels.countryofbirth"
                v-model="user.countryofbirth"
                :items="countries"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                :search-input.sync="searchcountry"
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object 
                ></v-autocomplete>


                <v-autocomplete
                v-if="user.countryofbirth && user.countryofbirth.Codice === config.iditalia"
                :label="labels.cityofbirth"
                v-model="user.cityofbirth"
                :items="cities"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-autocomplete>
                <!--:search-input.sync="searchcity_birth"-->

                <v-autocomplete
                :label="labels.citizenship"
                v-model="user.citizenship"
                :items="countries"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                :search-input.sync="searchcountry"
                item-text="Descrizione"
                item-value="Codice"
                required
                :select="user.citizenship"
                return-object
                ></v-autocomplete>

                <v-select
                v-if="isprimary"
                :label="labels.documenttype"
                v-model="user.documenttype"
                :items="doctypes"
                :rules="[v => !!v || 'Campo obbligatorio']"
                autocomplete
                auto-select-first

                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-select>

                <v-text-field
                v-if="isprimary"
                :label="labels.documentnumber"
                v-model="user.documentnumber"
                :rules="nameRules"
                required></v-text-field>

                <v-autocomplete
                v-if="isprimary"
                :label="labels.countryofissue"
                v-model="user.countryofissue"
                :items="countries"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                :search-input.sync="searchcountry"
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-autocomplete>

                <v-autocomplete
                v-if="isprimary && user.countryofissue && user.countryofissue.Codice === config.iditalia"
                :label="labels.cityofissue"
                v-model="user.cityofissue"
                :items="cities"
                :rules="[v => v.Codice && Number(v.Codice>0)  || 'Campo obbligatorio']"
                autocomplete
                auto-select-first
                
                item-text="Descrizione"
                item-value="Codice"
                required
                return-object
                ></v-autocomplete>
                <!--:search-input.sync="searchcity_issue"-->

                <!-- Data rilascio documento-->
                <label v-if="VisDocDataRilascio && isprimary" style="color:#0000008a; font-size: 12px;" >{{labels.dateofissue}}</label>
                <v-row v-if="VisDocDataRilascio && isprimary">
                <v-col>
                <v-select
                :label="labels.dayofissue"
                v-model="user.dayofissue"
                :items="days"
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>

                <v-col>
                <v-select
                :label="labels.monthofissue"
                v-model="user.monthofissue"
                :items="months" 
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>
                <v-col>
                <v-combobox
                :label="labels.yearofissue"
                v-model="user.yearofissue"
                :items="years"
                return-object
                :rules="nameRules"
                required></v-combobox>
                </v-col>
                </v-row>
                
                <!-- Data scadenza documento-->
                <label v-if="VisDocDataScadenza && isprimary" style="color:#0000008a; font-size: 12px;" >{{labels.dateofexpiration}}</label>
                <v-row v-if="VisDocDataScadenza && isprimary">
                <v-col>
                <v-select
                :label="labels.dayofexpiration"
                v-model="user.dayofexpiration"
                :items="days"
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>

                <v-col>
                <v-select
                :label="labels.monthofexpiration"
                v-model="user.monthofexpiration"
                :items="months" 
                return-object
                :rules="nameRules"
                required></v-select>
                </v-col>
                <v-col>
                <v-combobox
                :label="labels.yearofexpiration"
                v-model="user.yearofexpiration"
                :items="years_future"
                return-object
                :rules="nameRules"
                required></v-combobox>
                </v-col>
                </v-row>

                <!-- ente rilascio doc-->
                <v-text-field
                v-if="isprimary && VisDocEnteRilascio"
                :label="labels.issueby"
                v-model="user.issueby"
                :rules="[v => !!v || 'Campo obbligatorio']"
                required
                ></v-text-field>


                <v-text-field
                v-if="isprimary"
                :label="labels.email"
                v-model="user.email"
                :rules="emailRules"
                required
                ></v-text-field>
      
                <v-text-field
                v-if="user.countryofresidence && user.countryofresidence.Codice === config.iditalia && VisualizzaCodiceFiscale && isprimary"
                :label="labels.codfiscale"
                v-model="user.fiscalcode"
                :rules="[v => !!v || 'Campo obbligatorio']"
                required
                ></v-text-field>

                <v-text-field
                v-if=" VisualizzaTelefono && isprimary"
                :label="labels.phone"
                v-model="user.phone"
                :rules="[v => !!v || 'Campo obbligatorio']"
                required
                ></v-text-field>

                <v-text-field
                v-if="VisualizzaTarga && isprimary"
                :label="labels.targa"
                v-model="user.targa"
                :rules="[v => !!v || 'Campo obbligatorio']"
                required
                ></v-text-field>

                <div :class="{'input-error': !user.imgfront && showErrors_fronte}">
                  <upload v-model ="user.imgfront" v-if="isprimary && VisualizzaFoto" :filename ="Reservationid+'fronte'" :label="labels.imgfront" :oninput="immagine_fronte_caricata()" ></upload>
                  <span v-if="showErrors_fronte"  class="msg-foto-mancante">Carica una immagine. Upload a picture.</span>
                </div>
                <div :class="{'input-error': !user.imgback && showErrors_retro}">
                  <upload v-model ="user.imgback" v-if="isprimary && VisualizzaFoto" :filename ="Reservationid+'retro'" :label="labels.imgback"></upload>
                  <span v-if="showErrors_retro" class="msg-foto-mancante">Carica una immagine. Upload a picture.</span>
                </div>
                <v-checkbox v-if="DatiFatturaAbilitati && isprimary" v-model="confattura" :label="labels.invoice_check">
                </v-checkbox>

                <v-card v-if="confattura && DatiFatturaAbilitati" ma-3>
                <v-card-title><v-icon large >mdi-note</v-icon> <h3>{{labels.ditta_dati_fatturazione}}</h3></v-card-title>
                <v-card-text>
                    <v-text-field
                    :label="labels.ditta_ragionesociale"
                    v-model="user.ditta.ragionesociale"
                    :rules="nameRules"
                    required></v-text-field>

                    <v-select
                    :label="labels.ditta_country"
                    v-model="user.ditta.country"
                    :items="countries"
                    :rules="[v => !!v || 'Campo obbligatorio']"
                    autocomplete
                    auto-select-first
                    :search-input.sync="searchcountry"
                    item-text="Descrizione"
                    item-value="Codice"
                    required
                    return-object
                    ></v-select>

                
  
                    <v-combobox
                    v-if="user.ditta.country && user.ditta.country.Codice === config.iditalia"
                    :label="labels.ditta_city"
                    v-model="user.ditta.city"
                    :items="cities"
                    :rules="[v => !!v || 'Campo obbligatorio']"
                    autocomplete
                    auto-select-first
                    item-text="Descrizione"
                    item-value="Codice"
                    required
                    return-object
                    ></v-combobox>
                    <!--:search-input.sync="searchcity_ditta"-->

                    <v-text-field
                    v-if="user.ditta.country && user.ditta.country.Codice !== config.iditalia"
                    :label="labels.ditta_city"
                    v-model="user.ditta.foreign_city"
                    :rules="[v => !!v || 'Campo obbligatorio']"
                    required
                    return-object
                    ></v-text-field>

                    <v-text-field
                    :label="labels.ditta_indirizzo"
                    v-model="user.ditta.indirizzo"
                    :rules="nameRules"
                    required></v-text-field>
                    
                    <v-text-field
                    :label="labels.ditta_cap"
                    v-model="user.ditta.cap"
                    :rules="nameRules"
                    required></v-text-field>

                    <v-text-field
                    :label="labels.ditta_piva"
                    v-model="user.ditta.piva"
                    :rules="nameRules"
                    required
                    ></v-text-field>
                    
                    <v-text-field
                    v-if="user.ditta.country && user.ditta.country.Codice === config.iditalia"
                    :label="labels.ditta_codice_fiscale"
                    v-model="user.ditta.codice_fiscale"
                    :rules="nameRules"
                    required></v-text-field>

                    <v-text-field
                    v-if="user.ditta.country && user.ditta.country.Codice === config.iditalia"
                    :label="labels.ditta_codice_destinatario"
                    v-model="user.ditta.codice_destinatario"
                    :rules="nameRules"
                    required></v-text-field>

                    <v-text-field
                    v-if="user.ditta.country && user.ditta.country.Codice === config.iditalia"
                    :label="labels.ditta_pec"
                    v-model="user.ditta.pec"
                    ></v-text-field>
                    </v-card-text>
                    
                </v-card>
                
                






                

          <v-container >
             <v-row >
               
                <v-col align="center" justify="center">
                    <v-btn  color="success" medium rounded
                    @click="submit"
                    :disabled="!valid || PrenotazioneChiusa"
                    >{{labels.next}}<v-icon>mdi-check </v-icon>
                    
                    </v-btn>
                </v-col>

                <v-col align="center" justify="center" v-if="$store.state.config.CanAddGuest > 0 && false" > 
                        <v-btn error round medium dark @click.native.stop="dialog = true" v-if="!isprimary"><v-icon>mdi-delete</v-icon></v-btn>
                        <v-dialog v-model="dialog" max-width="290">
                          <v-card>
                            
                                <v-card-text>Sei sicuro di voler eliminare questo ospite?</v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" flat="flat" @click.native="dialog = false">Annulla</v-btn>
                              <v-btn color="primary" flat="flat" @click="$store.commit('removeGuest',user)" v-if="!isprimary">Elimina</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                    </v-col>




               
             
             </v-row>
            </v-container>
            </v-form>

        </v-container>
        <!--
        <v-card-actions>
          <v-btn flat color="orange" @click="autentica">Autentica</v-btn>
          <v-btn flat color="orange">Explore</v-btn>
        </v-card-actions>
        -->

        
        <!-- Dialog errore data -->
    <v-dialog
      v-model="erroredata"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline orange lighten-2"
          primary-title
        >
          <v-icon x-large>mdi-warning</v-icon>Attenzione
        </v-card-title>

        <v-card-text>
          <h2>Verifica la data di nascita</h2>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="erroredata = false"
          >
            <h2>OK</h2>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      </v-card>
      
      
  
  <!--</v-container>-->
  
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    dialog: false,
    confattura: false,
    erroredata : false,
    allineato_a_db: false,
    options: [{name: 'M', code: 'M'}, {name: 'F', code: 'F'}],
    genders: [{Codice: 'M', Descrizione: 'M'}, {Codice: 'F', Descrizione: 'F'}],
    countries: [],
    // cities: [],
    doctypes: [],
    user: {
        id: '',
        firstName: '',
        lastName: '',
        image: '',
        gender: '',
        dateofbirth: '',
        countryofbirth: '',
        countryofresidence: '',
        countryofissue: '',
        cityofissue: '',
        citizenship: '',
        cityofresidence: '',
        cityyofbirth: '',
        addressofresidence: '',
        email:'',
        documenttype: null,
        ismodified: false,
        imgfront: '',
        imgback: '',
        ditta:{
        },
    },
    valid: true,
    name: "",
    search: "",
    _searchcountry:"",
    searchcity_res:"",
    searchcity_issue:"",
    searchcity_birth:"",
    searchcity_ditta:"",
    searchdoc:"",
    nameRules: [
      v => !!v || "Inserisci un nome "
    ],
    email: "",
    emailRules: [
      v => !!v || "Inserisci una E-Mail",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "L'E-Mail deve essere valida"
    ],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
    days:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
    months:[1,2,3,4,5,6,7,8,9,10,11,12],
    showErrors_fronte: false,
    showErrors_retro:false
  }),
  watch: {
    countryofresidence(val){
      console.log("stato variato",val,this.user.countryobirth,this.user.citizenship)
        //this.user.countryofresidence =val
        if (val && val.Codice == this.config.iditalia){
            if(this.user.countryofbirth == null || this.user.countryofbirth =='' || this.user.countryofbirth == undefined){
                this.user.countryofbirth = val
            }
            if(!this.user.citizenship || this.user.citizenship == null || this.user.citizenship == '' || this.user.citizenship == undefined){
                this.user.citizenship = val
            }
            if(!this.user.countryofissue || this.user.countryofissue == null || this.user.countryofissue == '' || this.user.countryofissue == undefined){
                this.user.countryofissue = val
            }
        }
    },
    search (val) {
        console.log(val)
        val && this.querySelections(val)
      },
    searchdoc (val) {
        val && this.querySelections(val, 'documents')
      },
    'datimainguest.ismodified': function (val, oldVals) {
        // this.$store.commit('updateMainguest', { 'firstName': val })
        console.log('lastname modified', this.datimainguest,val,oldVals)
        if (!this.allineato_a_db) {
          Object.assign(this.user, this.datimainguest)
          this.allineato_a_db = true
          console.log('OGGETTO ALLINEATO A DB', this.datimainguest)
        }
      },
      searchcity_res (val) {
        val && this.querySelections(val,'cities')
      },
      searchcity_issue (val) {
        val && this.querySelections(val,'cities')
      },
      searchcity_ditta (val) {
        val && this.querySelections(val,'cities')
      },
      searchcity_birth (val) {
        val && this.querySelections(val,'cities')
      },
      linguacorrente(val){
        console.log('cambio lingua',val)
        this.caricaTipiDoc ();
      }
    },
  props: ['datimainguest', 'labels', 'config', 'isprimary'],
  computed:{
    ...mapGetters({
      linguacorrente: 'getCurrentLan'
    }),
      cities(){
       return this.$store.state.comuni2
     },
      countryofresidence:{
        get: function(){
          return this.user.countryofresidence;
        },
        set: function(val){
          this.user.countryofresidence = val;
        },
        
      },
      PrenotazioneChiusa(){
        return this.$store.state.reservation.status === 'CLOSED';
      },
      Reservationid(){
        return this.$store.state.reservation._id ;
      },
      DatiFatturaAbilitati(){
        return this.$store.state.config.AbilitaDatiFattura &&  this.$store.state.config.AbilitaDatiFattura == 1;
      },
      VisualizzaCodiceFiscale(){
        return this.$store.state.config.VisualizzaCodiceFiscale &&  this.$store.state.config.VisualizzaCodiceFiscale == 1;
      },
      VisualizzaTelefono(){
        return this.$store.state.config.VisualizzaTelefono &&  this.$store.state.config.VisualizzaTelefono == 1;
      },
      VisualizzaTarga(){
        return this.$store.state.config.VisualizzaTarga &&  this.$store.state.config.VisualizzaTarga == 1;
      },
      VisDocDataRilascio(){
        return this.$store.state.config.VisDocDataRilascio &&  this.$store.state.config.VisDocDataRilascio == 1;
      },
      VisDocDataScadenza(){
        return this.$store.state.config.VisDocDataScadenza &&  this.$store.state.config.VisDocDataScadenza== 1;
      },
      VisDocEnteRilascio(){
        return this.$store.state.config.VisDocEnteRilascio &&  this.$store.state.config.VisDocEnteRilascio == 1;
      },
      VisualizzaFoto(){
        return this.$store.state.config.fotodocumenti &&  this.$store.state.config.fotodocumenti == 1;        
      },
      years(){
        var anni=[];
        var d = new Date();
        var n = d.getFullYear();
        for (let index = 0; index < 120; index++) {
            anni.push(n-index)
        }
        return anni;

      },
      years_future(){
        var anni=[];
        var d = new Date();
        var n = d.getFullYear();
        for (let index = -2; index < 100; index++) {
            anni.push(n+index)
        }
        return anni;

      },
    searchcountry(val) {
        return val && this.querySelectionsCountries(val,'countries')     
      },


  },
  methods: {
    validateImages() {
      if (this.$store.state.config.fotodocobb == 1 && this.isprimary) {
        if (!this.user.imgfront || !this.user.imgback) {
          this.showErrors_fronte = !this.user.imgfront;
          this.showErrors_retro = !this.user.imgback;
          //alert('Both front and back images are required.');
          return false;
        }
      }
      return true;
    },
    isValidDate(d) {
      return (d instanceof Date && !isNaN(d) && d.getDate() == this.user.dayofbirth );
    },
    submit() {
      this.user.dateofbirth =  new Date(this.user.yearofbirth, this.user.monthofbirth-1, this.user.dayofbirth,12,0,0);
      console.log("DATA DI NASCITA:",this.user.dateofbirth)
      console.log("citta DI NASCITA:",this.user.cityofbirth)
      if (this.$refs.form.validate() && this.validateImages()) {
        if(this.isValidDate(new Date(this.user.dateofbirth))){
          this.erroredata = false;
          if(this.isprimary)
          {
              this.user.isprimary = true
              this.$store.commit('updateMainguest', this.user)
              this.$store.dispatch('precheckins/insert', this.$store.state.reservation).then(()=>{console.log("precheckin memorizzato")}).catch(err=>{console.log(err)})
          }
          else
          {
              this.$store.commit('updateGuest', this.user)         
          }
            
           this.$store.commit('editNextGuest', this.user)
           this.$vuetify.goTo('#curr_element', {})
        }
        else{
          this.erroredata = true;
        }

          
      }
    },
    clear() {
      this.$refs.form.reset();
    },
    immagine_fronte_caricata(){
      //alert("immagine fronte OK "+this.user.imgfront);
      console.log("immagine fronte OK ",this.user.imgfront.url);
      if(this.user.imgfront.url){
        this.$store.dispatch('EseguiOCRDoc', {documentUri:this.user.imgfront.url}).then((x)=>{
          console.log("result ocr",x)
          let document = x.data
          if(document){
            let doctype = document.documentType;
              console.log(doctype);
              for (const [key, ogg] of Object.entries(document.fields)) {
                console.log(`->${key}: ${ogg.content}`);
                if(key == "FirstName"){
                  console.log("NOME TROVATO", ogg.content)
                  this.user.firstName = ogg.content
                }
                if(key == "LastName"){
                  this.user.lastName = ogg.content
                }
                if(key == "DocumentNumber"){
                  this.user.documentnumber = ogg.content
                }
                if(key == "DateOfBirth"){
                  const words = ogg.content.split('.');
                  this.user.dayofbirth = words[0];
                  this.user.monthofbirth = words[1];
                  this.user.yearofbirth = words[2];
                }

                
              }
          }
          
          
        }).catch(err=>{console.log(err)})
      }
      
    },
    querySelections (v,table) {

      var apiurl = this.$store.state.settings.apiurl
      console.log('searching...', v,apiurl,table)
      this.loading = true
      if (table) {
          console.log('esecuzione GET... per '+ table)
        this.$http.get(apiurl + '/' + table, {params: {q: v, 'token': this.$store.state.settings.token }}
        ).then(resp => {
          console.log('RISP', resp)
          if(table == 'cities')
          {
             //this.cities = resp.body  
             this.cities =[].concat(this.cities,resp.body); //aggiungo all'array delle città la città selezionata
             console.log("carico città",resp.body)
          }
          if(table == 'countries')
          {
             //this.countries = resp.body  
             this.countries =[].concat(this.countries,resp.body);
             
             console.log("carico stati",resp.body)
          }

          if(table == 'documents')
          {
             this.doctypes = resp.body  
             console.log("carico documenti",resp.body)
          }

          
          this.loading = false
        })
      }
    },
    caricaTipiDoc () {
      const apiurl = this.$store.state.settings.apiurl
      const table = "documents"
      this.loading = true
      if (table) {
        if(this.$store.state.currentlan == 'it'){
            console.log('esecuzione GET... per '+ table)
            this.$http.get(apiurl + '/' + table, {params: {q: '', 'token': this.$store.state.settings.token }}
          ).then(resp => {
            console.log('RISP', resp)
            this.doctypes = resp.body.sort(function(a, b){
                  if(a.Descrizione < b.Descrizione) { return -1; }
                  if(a.Descrizione > b.Descrizione) { return 1; }
                  return 0;
              });
            this.loading = false
          })
        }
        else{
          this.doctypes =[{Codice:'IDENT',Descrizione:'IDENTITY CARD'},{Codice:'PASOR',Descrizione:'PASSPORT'}];
        }

      }
    },
      querySelectionsCountries (v,table) {
        console.log(v,table)
        this.countries = this.$store.state.countries;
      },
/*
        this.loading = true
        this.$http.get("http://192.168.2.173:3000/cities?q="+v
          ).then(resp => {
            console.log(resp);
            this.items = resp.body;
            this.loading = false
          });
          */

    autentica() {
      this.$store.commit("auth");
    }
  },
  created () {
      console.log('Scheda Persona in creazione****', this.datimainguest)
      Object.assign(this.user, this.datimainguest)
    this.caricaTipiDoc();
    if(this.user.documenttype)  
      this.doctypes.push(this.user.documenttype)
      

    //if(this.user.citizenship &&  !this.countries.find(x=>x.Codice == this.user.citizenship.Codice))  
    //  this.countries.push(this.user.citizenship)
    
    if(this.user.citizenship && (typeof this.user.citizenship) == "number"){
        var a = this.$store.state.countries.find(x=>x.Codice == this.user.citizenship)
        this.user.citizenship = a;
    }

    //if(this.user.countryofresidence && !this.countries.find(x=>x.Codice == this.user.countryofresidence.Codice))  
    //  this.countries.push(this.user.countryofresidence)

    if(this.user.countryofresidence && (typeof this.user.countryofresidence) == "number"){
        var x = this.$store.state.countries.find(x=>x.Codice == this.user.countryofresidence)
        this.user.countryofresidence = x;
    }

    //if(this.user.countryofbirth &&  !this.countries.find(x=>x.Codice == this.user.countryofbirth.Codice))  
    ///  this.countries.push(this.user.countryofbirth)

    if(this.user.countryofbirth && (typeof this.user.countryofbirth) == "number"){
        var z = this.$store.state.countries.find(x=>x.Codice == this.user.countryofbirth)
        this.user.countryofbirth = z;
    }

    //if(this.user.countryofissue &&  !this.countries.find(x=>x.Codice == this.user.countryofissue.Codice))  
    //  this.countries.push(this.user.countryofissue)

    if(this.user.countryofissue && (typeof this.user.countryofissue) == "number"){
        var xy = this.$store.state.countries.find(x=>x.Codice == this.user.countryofissue)
        this.user.countryofissue = xy;
    }
      

    if(this.user.cityofresidence && (typeof this.user.cityofresidence) == "number"){
        var xyz = this.cities.find(x=>x.Codice == this.user.cityofresidence)
        this.user.cityofresidence = xyz;
    }
    if(this.user.cityofbirth && (typeof this.user.cityofbirth) == "number"){
        var xyy = this.cities.find(x=>x.Codice == this.user.cityofbirth)
        this.user.cityofbirth = xyy;
    }
    if(this.user.cityofissue && (typeof this.user.cityofissue) == "number"){
        var xyt = this.cities.find(x=>x.Codice == this.user.cityofissue)
        this.user.cityofissue = xyt;
    }

/*
    if(this.user.cityofresidence  && !this.cities.find(x=>x.Codice == this.user.cityofresidence.Codice) )  
      this.cities.push(this.user.cityofresidence)

    if(this.user.cityofbirth  && !this.cities.find(x=>x.Codice == this.user.cityofbirth.Codice) )  
      this.cities.push(this.user.cityofbirth)

    if(this.user.cityofissue  && !this.cities.find(x=>x.Codice == this.user.cityofissue.Codice) )  
      this.cities.push(this.user.cityofissue)
      */


      //console.log('stati',this.countries)
      console.log('Scheda Persona CREATA****')
    }
};
</script>
<style>
.input-error {
  border: 1px solid red;
  background-color:rgba(255, 0, 0, 0.3);
}
.msg-foto-mancante {
    margin-left: 30px;
    font-size: small;
    color: red;
    /* margin-top: -5px; */
}
</style>